module.exports = __webpack_public_path__ + "img/1-3.36728988.webp";